import { ZodError, ZodIssue } from 'zod'
import { FormattedZodError } from './types'

export function formatZodErrors(filePath: string, zodError: ZodError<any>): FormattedZodError[] {
	const formattedErrors: FormattedZodError[] = zodError.errors.map((error: ZodIssue) => {
		const path = error.path.join(' -> ') || 'root'
		const formattedError: FormattedZodError = {
			filePath,
			path,
			message: error.message,
		}

		if (error.code === 'invalid_type') {
			formattedError.details = {
				expected: error.expected as string,
				received: error.received as string,
			}
		} else if (error.code === 'too_small') {
			formattedError.details = {
				minimum: error.minimum as number,
			}
		} else if (error.code === 'too_big') {
			formattedError.details = {
				maximum: error.maximum as number,
			}
		}

		return formattedError
	})

	return formattedErrors
}
